export default "__VITE_ASSET__e5d027cb__"